import { gql } from '@apollo/client';

import { CREATE_ADS_WITH_CREATIVES_AD_ITEM_FIELDS } from '../fragments';

export const CREATE_ADS_WITH_CREATIVES = gql`
  mutation CreateAdsWithCreatives($ads: [AdWithCreativeRefInput!]!, $creatives: [CreativeWithRefInput!]!) {
    createAdsWithCreatives(ads: $ads, creatives: $creatives) {
      lineItems {
        lineItemId
        ads {
          ...CreateAdsWithCreativesAdItemFields
        }
      }
    }
  }
  ${CREATE_ADS_WITH_CREATIVES_AD_ITEM_FIELDS}
`;
